import { Link } from 'react-router-dom';
import { DiscgoLogo } from './DiscgoLogo';

export function CTAFooter() {

  return (
    <footer className="bg-foreground text-background py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Logo & Description */}
            <div className="md:col-span-2 space-y-4">
              <div className="flex items-center">
                <DiscgoLogo variant="white" style={{ height: '53px', width: '53px' }} />
              </div>
              <p className="text-background/70 max-w-md">
                connecting disc golf players with private courses. 
                book amazing rounds, manage your course, grow the community.
              </p>
            </div>

            {/* Quick Links */}
            <div className="space-y-4">
              <h4 className="font-medium uppercase tracking-wide text-sm">quick links</h4>
              <div className="space-y-2 text-sm">
                <a href="/#players" className="block text-background/70 hover:text-background transition-colors">
                  how it works
                </a>
                <a href="/#giving-back" className="block text-background/70 hover:text-background transition-colors">
                  giving back
                </a>
                <a href="mailto:discgoinfo@gmail.com" className="block text-background/70 hover:text-background transition-colors">
                  contact us
                </a>
              </div>
            </div>

            {/* Legal */}
            <div className="space-y-4">
              <h4 className="font-medium uppercase tracking-wide text-sm">legal</h4>
              <div className="space-y-2 text-sm">
                <Link to="/privacy-policy" className="block text-background/70 hover:text-background transition-colors">
                  privacy policy
                </Link>
                <Link to="/terms-of-service" className="block text-background/70 hover:text-background transition-colors">
                  terms of service
                </Link>

              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-background/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-background/70">
            <p>&copy; 2026 discgo. all rights reserved.</p>
            <p>made with ❤️ for the disc golf community</p>
          </div>
        </div>
      </footer>
  );
}